import { findFlagUrlByCountryName } from "country-flags-svg";
import Select from "../../Components/Input/Select/Select";
import Button from "../../Components/Buttons";
import numeral from "numeral";
import { useHistory } from "react-router-dom";
import routes from "../../utils/routes";
import getNumberText from "../../utils/getNumberText";
import Loader from "../../Components/Lottie";
import loader from "../../Assets/json/spinner.json";

const DataCard = ({
  countrySelect,
  activeCountry,
  selectCountryHandler,
  countryDiseaseMap = {},
  countryDonationSummary,
  fetchingCountrySummary,
  vaccinations,
  fetchingVaccinations,
}) => {

  const { push } = useHistory();
  const diseaseData = countryDiseaseMap[activeCountry?.name?.toLowerCase()];
  
  const navigateToCountry = () => {
    push(`${routes.countries}/${activeCountry?.name}`);
  };

  return (
    <div className="bg-white md:px-8 px-6 rounded">
      <div className="py-6 slg:pb-3">
        <Select
          placeholder="Country"
          value={activeCountry?.content?.id}
          onChange={selectCountryHandler}
          options={countrySelect}
        />
      </div>
      {!!activeCountry?.content?.id && (
        <div className="pb-6">
          <div className="flex items-center">
            <h6 className="text-boudoir font-medium text-xl leading-30 mr-2 capitalize">
              {activeCountry?.name}
            </h6>
            {!!findFlagUrlByCountryName(activeCountry?.name) && (
              <span className="h-4 w-8 bg-moon flex-shrink-0">
                <img
                  src={findFlagUrlByCountryName(activeCountry?.name)}
                  alt={activeCountry?.name}
                />
              </span>
            )}
          </div>
          <div className="pt-4 md:flex md:flex-wrap slg:flex-col slg:pt-3 ">
            <h6 className=" md:w-1/3 slg:w-full flex-shrink-0 font-medium text-lg leading-7 text-boudoir mb-4 last:mb-0 slg:mb-1.5 slg:last:mb-0 slg:text-base">
              {!!diseaseData ? numeral(diseaseData?.cases).format() : "N/A"}
              <span className=" text-metal text-xs font-normal leading-18">
                &nbsp;Total cases
              </span>
            </h6>
            <h6 className=" md:w-1/3 slg:w-full flex-shrink-0 font-medium text-lg leading-7 text-boudoir mb-4 last:mb-0 slg:mb-1.5 slg:last:mb-0 slg:text-base">
              {!!diseaseData ? numeral(diseaseData?.active).format() : "N/A"}
              <span className="mr-1 text-metal text-xs font-normal leading-18">
                &nbsp;Active cases
              </span>
            </h6>
            <h6 className=" md:w-1/3 slg:w-full flex-shrink-0 font-medium text-lg leading-7 text-boudoir mb-4 last:mb-0 slg:mb-1.5 slg:last:mb-0 slg:text-base">
              {!!diseaseData ? numeral(diseaseData?.deaths).format() : "N/A"}
              <span className="mr-1 text-metal text-xs font-normal leading-18">
                &nbsp;Deaths
              </span>
            </h6>
            <h6 className=" md:w-1/3 slg:w-full flex-shrink-0 font-medium text-lg leading-7 text-boudoir mb-4 last:mb-0 slg:mb-1.5 slg:last:mb-0 slg:text-base flex items-center">
              {!fetchingCountrySummary &&
                (() => {
                  const result = getNumberText(
                    countryDonationSummary?.materialDonations
                  );
                  return (
                    <>
                      {!!Number(result?.value) && (
                        <>
                          {" "}
                          ${result?.value}
                          <span className="text-sm">{result?.unit}</span>{" "}
                        </>
                      )}
                      {!Number(result?.value) && (
                        <>
                          {" "}
                          <span className="text-metal text-xs font-normal leading-18">
                            No data for
                          </span>{" "}
                        </>
                      )}
                    </>
                  );
                })()}
              {fetchingCountrySummary && (
                <span className="w-4 h-4 inline-block">
                  <Loader loader={loader} />
                </span>
              )}
              <span className="mr-1 text-metal text-xs font-normal leading-18">
                &nbsp;In-Kind Donations
              </span>
            </h6>
            <h6 className=" md:w-1/3 slg:w-full flex-shrink-0 font-medium text-lg leading-7 text-boudoir mb-4 last:mb-0 slg:mb-1.5 slg:last:mb-0 slg:text-base">
              {!fetchingCountrySummary &&
                (() => {
                  const result = getNumberText(
                    countryDonationSummary?.resourceCommitted
                  );
                  return (
                    <>
                      {!!Number(result?.value) && (
                        <>
                          {" "}
                          ${result?.value}
                          <span className="text-sm">{result?.unit}</span>{" "}
                        </>
                      )}
                      {!Number(result?.value) && (
                        <>
                          {" "}
                          <span className="text-metal text-xs font-normal leading-18">
                            No data for total
                          </span>
                        </>
                      )}
                    </>
                  );
                })()}
              {fetchingCountrySummary && (
                <span className="w-4 h-4 inline-block">
                  <Loader loader={loader} />
                </span>
              )}
              <span className="mr-1 text-metal text-xs font-normal leading-18">
                &nbsp;Resources Committed
              </span>
            </h6>
            <h6 className=" md:w-1/3 slg:w-full flex-shrink-0 font-medium text-lg leading-7 text-boudoir mb-4 last:mb-0 slg:mb-1.5 slg:last:mb-0 slg:text-base">
              {!fetchingVaccinations &&
                (() => {
                  const result = getNumberText(vaccinations);
                  return (
                    <>
                      {!!Number(result?.value) && (
                        <>
                          {result?.value}
                          <span className="text-sm">{result?.unit}</span>{" "}
                        </>
                      )}
                      {!Number(result?.value) && (
                        <>
                          {" "}
                          <span className="text-metal text-xs font-normal leading-18">
                            No data for total
                          </span>
                        </>
                      )}
                    </>
                  );
                })()}
              {fetchingVaccinations && (
                <span className="w-4 h-4 inline-block">
                  <Loader loader={loader} />
                </span>
              )}
              <span className="mr-1 text-metal text-xs font-normal leading-18">
                &nbsp;Vaccinations
              </span>
            </h6>
          </div>
          <div className="mt-4  slg:block lg:mt-6">
            <Button type="button" onClick={navigateToCountry}>
              <span className="py-3 slg:py-2 inline-block text-center w-full font-medium text-sm leading-5">
                View Country
              </span>
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default DataCard;
